// ----------------------------------------------------------------------
// <copyright file="Izenda.RelationshipConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import localizer from 'share/localization/Izenda.Localizer';

export default {
  FIELDCHECK: {
    JOIN_QUERYSOURCE_FIELD: 'joinQuerySourceId',
    POSITION_ID: 'positionId',
    JOIN_FIELD: 'joinFieldId',
    FOREIGN_QUERYSOURCE_FIELD: 'foreignQuerySourceId',
    FOREIGN_FIELD: 'foreignFieldId',
    JOIN_TYPE: 'joinType',
    DATABASE_FIELD: 'joinConnectionId',
    FOREIGN_DATABASE_FIELD: 'foreignConnectionId'
  },

  TABLE_DEF: {
    joinType: {
      key: 'joinType',
      width: 110,
      get title() {
        return localizer.getText('COMMON_LABEL_JOIN_TYPE');
      },
      sortAble: false
    },
    positionId: {
      key: 'PositionId',
      width: 110,
      get title() {
        return localizer.getText('COMMON_LABEL_POSITION');
      },
      sortAble: true
    },
    dbName: {
      key: 'DatabaseName',
      width: 150,
      get title() {
        return localizer.getText('COMMON_LABEL_DATABASE_NAME');
      },
      sortAble: true
    },
    dataObject: {
      key: 'DataObject',
      width: 150,
      get title() {
        return localizer.getText('COMMON_LABEL_DATA_OBJECT');
      },
      sortAble: true
    },
    joinField: {
      key: 'JoinField',
      width: 150,
      get title() {
        return localizer.getText('COMMON_LABEL_JOIN_FIELD');
      },
      sortAble: true
    },
    equal: { key: 'equal', width: 60, title: '', sortAble: false, fixed: true },
    frDbName: {
      key: 'ForeignDatabaseName',
      width: 150,
      get title() {
        return localizer.getText('COMMON_LABEL_DATABASE_NAME');
      },
      sortAble: true
    },
    frDataObject: {
      key: 'ForeignDataObject',
      width: 200,
      get title() {
        return localizer.getText('COMMON_LABEL_FOREIGN_DATA_OBJECT');
      },
      sortAble: true
    },
    frField: {
      key: 'Field',
      width: 150,
      get title() {
        return localizer.getText('COMMON_LABEL_FIELD');
      },
      sortAble: true
    },
    action: { key: 'action', width: 100, title: '', sortAble: false }
  },

  BUNDLE: {
    DEFAULT_CRITERIA_LIST: [
      {
        value: 'All',
        get label() {
          return localizer.getText('COMMON_LABEL_ALL');
        }
      },
      {
        value: 'DatabaseName',
        get label() {
          return localizer.getText('COMMON_LABEL_DATABASE_NAME');
        }
      },
      {
        value: 'DataObject',
        get label() {
          return localizer.getText('COMMON_LABEL_DATA_OBJECT');
        }
      },
      {
        value: 'ForeignDataObject',
        get label() {
          return localizer.getText('COMMON_LABEL_FOREIGN_DATA_OBJECT');
        }
      },
      {
        value: 'JoinField',
        get label() {
          return localizer.getText('COMMON_LABEL_JOIN_FIELD');
        }
      },
      {
        value: 'Field',
        get label() {
          return localizer.getText('COMMON_LABEL_FIELD');
        }
      }
    ],
    DATASOURCE_CRITERIA_LIST: [
      {
        value: 'All',
        get label() {
          return localizer.getText('COMMON_LABEL_ALL');
        }
      },
      {
        value: 'DatabaseName',
        get label() {
          return localizer.getText('COMMON_LABEL_DATABASE_NAME');
        }
      },
      {
        value: 'ForeignDataObject',
        get label() {
          return localizer.getText('COMMON_LABEL_FOREIGN_DATA_OBJECT');
        }
      },
      {
        value: 'JoinField',
        get label() {
          return localizer.getText('COMMON_LABEL_JOIN_FIELD');
        }
      },
      {
        value: 'Field',
        get label() {
          return localizer.getText('COMMON_LABEL_FIELD');
        }
      }
    ],
    SORTDEFAULTLIST: {
      DEFAULT_SORT: { PositionId: 'ASC' }
    },
    DEFAULT_CRITERIA: 'All'
  },

  get CONFIRM_DELETE_RELATIONSHIP() {
    return localizer.getText('RELATIONSHIP_MESSAGE_CONFIRM_DELETE_RELATIONSHIP');
  },
  get CONFIRM_DISABLE_RELATIONSHIP() {
    return localizer.getText('RELATIONSHIP_MESSAGE_CONFIRM_DISABLE_RELATIONSHIP');
  },
  get RELATIONSHIP_LABEL() {
    return localizer.getText('RELATIONSHIP_LABEL_RELATIONSHIP');
  },

  REQUIRED_CONSTRAINT: {
    presence: {
      presence: true,
      get message() {
        return localizer.getText('COMMON_CONSTRAINT_REQUIRED');
      }
    }
  },

  POSITION_ID: {
    FORMAT: '####',
    PATTERN: /^[1-9]\d{0,8}$/
  },

  JOIN_TYPE_CROSS: 'Cross'
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.RelationshipConstants.js